import { authClient } from "@/lib/auth-client";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth")({
  beforeLoad: async () => {
    try {
      const session = await authClient.getSession();
      if (session.data?.session) {
        throw redirect({ to: "/" });
      }
    } catch (err) {
      if (err && typeof err === "object" && "to" in err) {
        throw err;
      }
      // Backend API offline or unreachable — proceed to render auth route (login/landing)
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  return <Outlet />;
}
